// extracted by mini-css-extract-plugin
export default {"mCard":"iG-z","image":"jG-z","imageNoBackground":"kG-z","fullWidth":"lG-z"};